/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function GoogleIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center rounded-[8px]">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_7548_23054)">
          <path
            d="M15.68 8.17777C15.68 7.52 15.6266 7.04 15.5111 6.54223H8V9.51108H12.4089C12.32 10.2489 11.84 11.36 10.7733 12.1066L10.7584 12.206L13.1332 14.0458L13.2978 14.0622C14.8089 12.6667 15.68 10.6133 15.68 8.17777Z"
            fill="#4285F4"
          />
          <path
            d="M8 16C10.16 16 11.9733 15.2889 13.2978 14.0622L10.7733 12.1066C10.0978 12.5777 9.19108 12.9066 8 12.9066C5.88446 12.9066 4.08892 11.5111 3.44885 9.58223L3.35504 9.59019L0.885607 11.5013L0.853313 11.5911C2.16885 14.2044 4.87108 16 8 16Z"
            fill="#34A853"
          />
          <path
            d="M3.44885 9.58223C3.27997 9.08446 3.18223 8.55108 3.18223 8C3.18223 7.44885 3.27997 6.91554 3.43997 6.41777L3.4355 6.31176L0.935121 4.36994L0.853313 4.40885C0.311115 5.49331 0 6.71111 0 8C0 9.28889 0.311115 10.5066 0.853313 11.5911L3.44885 9.58223Z"
            fill="#FBBC05"
          />
          <path
            d="M8 3.09331C9.5022 3.09331 10.5155 3.7422 11.0933 4.28446L13.3511 2.08C11.9645 0.791114 10.16 0 8 0C4.87108 0 2.16885 1.79554 0.853313 4.40885L3.43997 6.41777C4.08892 4.48888 5.88446 3.09331 8 3.09331Z"
            fill="#EB4335"
          />
        </g>
        <defs>
          <clipPath id="clip0_7548_23054">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
